import StockRemove from "./StockRegularize";

export {StockRemove}
export default StockRemove
